import React, { useContext, useState } from "react";

import Heading from "components/Elements/Heading";
import { FaCog } from "react-icons/fa";
import SelectAccount from "../../pages/SourcePage/SelectAccounts";
import SourceSelected from "../../pages/SourcePage/SourceSelected";
import { selectIcon } from "components/Utils/Utils.js";
import { SourceContext } from "./SourcesMasterPage";

const SourceList = ({ sourceData }) => {
  const props = useContext(SourceContext);

  const hashURL = window.location.hash.substr(1);
  const decodedURL = decodeURIComponent(hashURL);

  const lastUrlParameter = decodedURL
    ? decodedURL.split("/").pop()
    : window.location.pathname.split("/").pop();

  const [sidebarOpen, setSidebarOpen] = useState(
    sourceData && sourceData.name.toLowerCase() === lastUrlParameter
  );

  const [showSelectAccount, setShowSelectAccount] = useState(
    sourceData && sourceData.name.toLowerCase() === lastUrlParameter
  );

  const openHandler = () => {
    if (!sidebarOpen) {
      window.history.replaceState({}, "", "/settings/sources");
      setSidebarOpen(true);
      props.disableSourceButton();
    } else {
      setSidebarOpen("sidebar close-selected");
      setTimeout(() => {
        setSidebarOpen(false);
      }, 600);
    }
  };

  const sidebarCloseHandler = () => {
    props.enableSourceButton();
    setShowSelectAccount(false);
    setSidebarOpen(false);
  };

  let sidebar;
  if (sidebarOpen) {
    sidebar = showSelectAccount ? (
      // SELECT ACCOUNT
      <SelectAccount
        closeSidebar={sidebarCloseHandler}
        sidebar={"sidebar"}
        sourceData={sourceData}
      />
    ) : (
      <SourceSelected
        closeSidebar={sidebarCloseHandler}
        sidebar={"sidebar"}
        sourceData={sourceData}
      />
    );
  }

  return (
    <div>
      {sourceData && sourceData.active === true ? (
        <>
          <div className="row">
            {sidebar}
            <div className="col-5 source-list_item">
              <div className="row pt-2">
                <div className="mr-3 pt-4">
                  <img
                    src={selectIcon(sourceData.type)}
                    alt={sourceData.type}
                    width="40"
                    height="40"
                  />
                </div>
                <div>
                  <Heading size={4} className="pt-4">
                    {sourceData.name}
                  </Heading>
                  <div>
                    <small>{sourceData.account_count} Accounts Connected</small>
                  </div>
                </div>
              </div>
            </div>

            <div className="ml-auto pr-3 col-6 pt-4 d-flex justify-content-end row align-items-center">
              <div className="row pt-1 mr-4 text-center">
                <div
                  className={
                    sourceData.account_count > 0
                      ? "status active-indicator"
                      : "status inactive-indicator"
                  }
                ></div>
                <div>
                  {sourceData.account_count > 0 ? "Active" : "Inactive"}
                </div>
              </div>
              <div className="col-1">
                <FaCog onClick={openHandler} className="edit-icon" />
              </div>
            </div>
          </div>
          <div className="border-between"></div>
        </>
      ) : null}
    </div>
  );
};
export default SourceList;
